// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1d9-k","rootSmall":"AddTileButton_rootSmall__3j8Uj"};